import { render, staticRenderFns } from "./complaintsList.vue?vue&type=template&id=497cb0b5&scoped=true&"
import script from "./complaintsList.vue?vue&type=script&lang=js&"
export * from "./complaintsList.vue?vue&type=script&lang=js&"
import style0 from "./complaintsList.vue?vue&type=style&index=0&id=497cb0b5&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497cb0b5",
  null
  
)

export default component.exports